import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class RappitTitleService extends Title {
  private readonly titleSuffix = ' - Rappit';
  private readonly fallbackTitle = 'Rappit';

  constructor(@Inject(DOCUMENT) document: Document) {
    super(document);
  }

  override setTitle(newTitle: string): void {
    super.setTitle(this.formatTitle(newTitle));
  }

  private formatTitle(pageTitle: string | null | undefined): string {
    const normalizedTitle = pageTitle?.trim();

    if (!normalizedTitle) {
      return this.fallbackTitle;
    }

    if (normalizedTitle.endsWith(this.titleSuffix)) {
      return normalizedTitle;
    }

    return `${normalizedTitle}${this.titleSuffix}`;
  }
}
